/**
 * Veiligheidsregel voor elk zichtbaar bedrag.
 *
 * Een prijs mag alleen op de website staan als het een echt, positief bedrag
 * uit de centrale prijs-engine (`tariffs.ts`) is. `null`, `undefined`, `NaN`,
 * tekst die geen getal is en 0 zijn géén geldige ritprijs: dan toont de pagina
 * geen bedrag maar een oproep om de prijs te berekenen.
 */

/** Geldig zichtbaar bedrag, of `null` wanneer er geen bedrag getoond mag worden. */
export function validPrice(value: unknown): number | null {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}

/** Mag dit bedrag als prijs op de pagina staan? */
export function hasPrice(value: unknown): boolean {
  return validPrice(value) !== null;
}

export const PRICE_CTA_NL = "Bereken uw vaste prijs";
export const PRICE_CTA_EN = "Calculate your fixed price";
